import { render } from "./left.vue?vue&type=template&id=31d25f90&ts=true"
import script from "./left.vue?vue&type=script&lang=ts"
export * from "./left.vue?vue&type=script&lang=ts"

import "./left.vue?vue&type=style&index=0&id=31d25f90&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__